// V3 navigation: which sidebar / bottom-bar item is active for a route (taken from the template, VISIBILIS_V3 PDF).
export const SIDE_NAV = [
  { key: "start", path: "/", label: "Start" },
  { key: "discover", path: "/suche", label: "Entdecken" },
  { key: "activities", path: "/aktivitaeten", label: "Aktivitäten" },
  { key: "groups", path: "/kreise", label: "Kreise" },
  { key: "messages", path: "/nachrichten", label: "Nachrichten" },
  { key: "plans", path: "/plaene", label: "Meine Pläne" },
  { key: "profile", path: "/profil", label: "Mein Profil" },
  { key: "pass", path: "/access-pass", label: "Mein Access Pass" },
  { key: "settings", path: "/einstellungen", label: "Einstellungen" },
  { key: "help", path: "/hilfe", label: "Hilfe" },
];

export const BOTTOM_NAV = [
  { key: "start", path: "/", label: "Start" },
  { key: "discover", path: "/suche", label: "Entdecken" },
  { key: "plans", path: "/plaene", label: "Pläne" },
  { key: "messages", path: "/nachrichten", label: "Nachrichten" },
  { key: "profile", path: "/mehr", label: "Profil" },
];

// Longest matching prefix wins; mapping follows the active item shown per view in the template.
const SECTION_BY_PREFIX = [
  ["/einrichtung", "profile"],
  ["/einrichtung/interessen", "discover"],
  ["/einrichtung/ansicht", "settings"],
  ["/einrichtung/privatsphaere", "settings"],
  ["/einrichtung/fertig", "discover"],
  ["/suche", "discover"],
  ["/community", "discover"],
  ["/menschen/", "profile"],
  ["/menschen", "discover"],
  ["/menschen/filtern", "discover"],
  ["/kontakte", "discover"],
  ["/benachrichtigungen", "discover"],
  ["/merkliste", "activities"],
  ["/aktivitaeten", "activities"],
  ["/kreise/vorschlagen", "settings"],
  ["/kreise", "groups"],
  ["/nachrichten", "messages"],
  ["/plaene", "plans"],
  ["/sicherheit/vertraute-kontakte", "plans"],
  ["/sicherheit", "plans"],
  ["/sicherheit/blockiert", "discover"],
  ["/profil", "profile"],
  ["/access-pass", "pass"],
  ["/einstellungen/daten", "discover"],
  ["/einstellungen/konto-loeschen", "discover"],
  ["/einstellungen/sitzungen", "discover"],
  ["/einstellungen", "settings"],
  ["/hilfe", "discover"],
  ["/organisationen", "discover"],
  ["/mehr", "profile"],
];

export function navSection(pathname) {
  const p = typeof pathname === "string" ? pathname : "";
  if (p === "/" || p === "") return "start";
  let best = null;
  for (const [prefix, key] of SECTION_BY_PREFIX) {
    const hit = prefix.endsWith("/") ? p.startsWith(prefix) && p.length > prefix.length : p === prefix || p.startsWith(`${prefix}/`);
    if (hit && (!best || prefix.length > best[0].length)) best = [prefix, key];
  }
  return best ? best[1] : null;
}

const BOTTOM_BY_SECTION = { start: "start", discover: "discover", activities: "discover", groups: "discover", plans: "plans", messages: "messages", profile: "profile", pass: "profile", settings: "profile", help: "discover" };

export const bottomSection = (pathname) => BOTTOM_BY_SECTION[navSection(pathname)] || null;

export function crumbLabel(pathname) {
  const item = SIDE_NAV.find((i) => i.key === navSection(pathname));
  return item ? `${item.label} / Mein Bereich` : "Mein Bereich";
}

// "Lea M." from a display name; nothing invented when the name is missing.
export { shortName } from "@/lib/v3People";
